<template>
    <ui-dropdown menu-class="p-3 w-64">
        <template #default="{ toggle }">
            <button title="Sorting and View" @click="toggle"
                    class="group h-[36px] w-[36px] cursor-pointer items-center justify-center rounded-lg hover:bg-gray-100 hidden md:inline-flex">
                <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.5"
                    fill-rule="evenodd"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    width="15px"
                    height="15px"
                    viewBox="0 0 20 16"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    class="preview-list-icon vue-feather group-hover-text-theme scale-125"
                >
                    <rect x="9.77777778" y="0" width="6.22222222"
                          height="6.22222222"></rect>
                    <rect x="9.77777778" y="9.77777778" width="6.22222222"
                          height="6.22222222"></rect>
                    <line x1="0" y1="2" x2="6" y2="2"></line>
                    <line x1="0" y1="8" x2="6" y2="8"></line>
                    <line x1="0" y1="14" x2="6" y2="14"></line>
                </svg>
            </button>
        </template>
        <template #menu="{ close }">
            <ui-dropdown-item ref="sortitem" icon="fa fa-sort"
                              @mouseleave="(e) => {$refs['sortmenu'].close(e)}"
                              @mouseenter="openSortSubMenu"
                              :submenu="true"
            >Sort By
                <div class="fixed" style="width:auto;height:auto;overflow: visible" :ref="'sortrelative'">
                    <vue-context :ref="'sortmenu'" class="inline pb-0 focus:outline-none focus:ring-0 z-30"
                                 :close-on-click="false" :close-on-scroll="false">
                        <div :id="'sortmenu'"
                             class="p-3 w-48 z-30 bg-white rounded-lg border border-gray-300 shadow-lg">
                            <ui-dropdown-item icon="fas fa-sort-alpha-down" @click="setSortBy('name');close();"
                                              :ticked="prefs.sortBy==='name'">Name
                            </ui-dropdown-item>
                            <ui-dropdown-item icon="fas fa-sort-numeric-down-alt"
                                              @click="setSortBy('created');close();"
                                              :ticked="prefs.sortBy==='created'">Created At
                            </ui-dropdown-item>
                            <ui-dropdown-item icon="fas fa-sort-numeric-down-alt"
                                              @click="setSortBy('modified');close();"
                                              :ticked="prefs.sortBy==='modified'">Modified At
                            </ui-dropdown-item>
                        </div>
                    </vue-context>
                </div>
            </ui-dropdown-item>
            <ui-dropdown-item ref="groupitem" icon="far fa-list-alt"
                              @mouseleave="(e) => {$refs['groupmenu'].close(e)}"
                              @mouseenter="openGroupSubMenu"
                              :submenu="true"
            >Group By
                <div class="fixed" style="width:auto;height:auto;overflow: visible" :ref="'grouprelative'">
                    <vue-context :ref="'groupmenu'" class="inline pb-0 focus:outline-none focus:ring-0 z-30"
                                 :close-on-click="false" :close-on-scroll="false">
                        <div :id="'groupmenu'"
                             class="p-3 w-48 z-30 bg-white rounded-lg border border-gray-300 shadow-lg">
                            <ui-dropdown-item icon="fa fa-tags"
                                              @click="setGroupBy('tags');close();"
                                              :ticked="prefs.groupBy==='tags'">Tags
                            </ui-dropdown-item>
                            <ui-dropdown-divider></ui-dropdown-divider>
                            <ui-dropdown-item icon="fas fa-calendar-plus"
                                              @click="setGroupBy('created');close();"
                                              :ticked="prefs.groupBy==='created'">Created At
                            </ui-dropdown-item>
                            <ui-dropdown-item icon="fas fa-user"
                                              @click="setGroupBy('createdBy');close();"
                                              :ticked="prefs.groupBy==='createdBy'">Created By
                            </ui-dropdown-item>
                            <ui-dropdown-divider></ui-dropdown-divider>
                            <ui-dropdown-item icon="fas fa-calendar-check"
                                              @click="setGroupBy('updated');close();"
                                              :ticked="prefs.groupBy==='updated'">Last Updated At
                            </ui-dropdown-item>
                            <ui-dropdown-item icon="fas fa-user-check"
                                              @click="setGroupBy('updatedBy');close();"
                                              :ticked="prefs.groupBy==='updatedBy'">Last Updated By
                            </ui-dropdown-item>
                            <ui-dropdown-divider></ui-dropdown-divider>
                            <ui-dropdown-item icon="fa fa-times" @click="setGroupBy('none');close();"
                                              :ticked="prefs.groupBy==='none' || !prefs.groupBy">No Grouping
                            </ui-dropdown-item>
                        </div>
                    </vue-context>
                </div>
            </ui-dropdown-item>
            <ui-dropdown-divider></ui-dropdown-divider>
            <ui-dropdown-item icon="far fa-folder-open"
                              @click="toggleFoldersOnTop();close();"
                              :ticked="prefs.foldersOnTop">
                Folders Always on Top
            </ui-dropdown-item>
            <ui-dropdown-divider></ui-dropdown-divider>
            <ui-dropdown-item icon="fas fa-list"
                              @click="prefs.size='small';setPrefs();close();"
                              :ticked="prefs.size==='small'">Compact List Mode
            </ui-dropdown-item>
            <ui-dropdown-item icon="fas fa-th-list"
                              @click="prefs.size='large';setPrefs();close();"
                              :ticked="prefs.size==='large'">Full List Mode
            </ui-dropdown-item>
            <ui-dropdown-divider v-if="canShowInfo"></ui-dropdown-divider>
            <ui-dropdown-item icon="fas fa-info" v-if="canShowInfo"
                              @click="toggleInfo();close()"
                              :ticked="prefs.showInfo">Show Information Panel
            </ui-dropdown-item>
            <ui-dropdown-item icon="fas fa-image" v-if="canShowInfo"
                              @click="togglePreview();close()"
                              :ticked="prefs.showPreview">Show Preview Panel
            </ui-dropdown-item>
        </template>
    </ui-dropdown>
</template>

<script>
import UiDropdownDivider from "../ui/UiDropdownDivider.vue";
import UiDropdownItem from "../ui/UiDropdownItem.vue";

export default {
    components: {UiDropdownItem, UiDropdownDivider},
    props: {
        prefs: Object,
        canShowInfo: true,

    },
    data() {
        return {}
    },
    computed: {},
    methods: {
        openSortSubMenu(e) {
            this.$refs["sortmenu"].open(new window.MouseEvent('mouse'))
            this.$nextTick(() => {
                this.$refs["sortrelative"].setAttribute('style', '')
                this.$nextTick(() => {
                    const opener = this.$refs.sortitem.$refs.submenu.getBoundingClientRect()
                    const box = this.$refs["sortmenu"].$el.getBoundingClientRect()
                    let left = Math.min(opener.x - box.x - 10, window.innerWidth - (box.right) - 17);
                    let top = Math.min(opener.y - box.y - 10, window.innerHeight - (box.bottom) - 28);
                    this.$refs["sortrelative"].setAttribute('style', 'margin-left:' + left + 'px; margin-top:' + top + 'px')
                })
            })
        },
        openGroupSubMenu(e) {
            this.$refs["groupmenu"].open(new window.MouseEvent('mouse'))
            this.$nextTick(() => {
                this.$refs["grouprelative"].setAttribute('style', '')
                this.$nextTick(() => {
                    const opener = this.$refs.groupitem.$refs.submenu.getBoundingClientRect()
                    const box = this.$refs["groupmenu"].$el.getBoundingClientRect()
                    let left = Math.min(opener.x - box.x - 10, window.innerWidth - (box.right) - 17);
                    let top = Math.min(opener.y - box.y - 10, window.innerHeight - (box.bottom) - 28);
                    this.$refs["grouprelative"].setAttribute('style', 'margin-left:' + left + 'px; margin-top:' + top + 'px')
                })
            })
        },
        toggleFoldersOnTop() {
            this.prefs.foldersOnTop = !this.prefs.foldersOnTop
            this.setPrefs();
        },
        setSortBy(o) {
            this.prefs.sortBy = o
            this.setPrefs();
        },
        toggleInfo() {
            this.prefs.showInfo = !this.prefs.showInfo
            this.setPrefs();
        },
        togglePreview() {
            this.prefs.showPreview = !this.prefs.showPreview
            this.setPrefs();
        },
        setGroupBy(o) {
            this.prefs.groupBy = o
            this.setPrefs();
        },
        setPrefs() {
            this.$emit('setPrefs', this.prefs)
        },

    },
    mounted() {
    }
}
</script>

